const READ_ONLY_MODE_KEY = 'partnerReadOnlyMode';

export function isPartnerReadOnlyMode(): boolean {
  if (localStorage.getItem(READ_ONLY_MODE_KEY) === '1') {
    return true;
  }

  const partnerTenantId = localStorage.getItem('partnerTenantId');
  const actingTenantId = localStorage.getItem('actingTenantId');
  const currentTenantId = localStorage.getItem('tenantId');

  return !!partnerTenantId && !!actingTenantId && currentTenantId === actingTenantId;
}

export function enablePartnerReadOnlyMode(): void {
  localStorage.setItem(READ_ONLY_MODE_KEY, '1');
}

export function disablePartnerReadOnlyMode(): void {
  localStorage.removeItem(READ_ONLY_MODE_KEY);
}
